<div fxLayout="column" class="timeline-container">
  <div class="top-line" [ngClass]="{ 'first-or-last': first }"></div>
  <div
    class="circle h-3.5 w-3.5 rounded-full"
    [ngClass]="{ 'filled-in': selected }"
  >
    <mat-icon class="!flex !items-center !justify-center" *ngIf="selected"
      >star</mat-icon
    >
  </div>
  <div fxFlex class="bottom-line" [ngClass]="{ 'first-or-last': last }"></div>
</div>

<div
  class="text-section mat-caption flex-1"
  [class.hidden]="closed && (isAboveSmall$ | async) === false"
>
  <ng-content></ng-content>
</div>
